
<template>
  <div
    class="m-map"
    v-loading="loading"
    id="bodyData"
    element-loading-text="正在加载，请稍等..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <template v-if="isLoadAllData">
      <!-- 全部道路 -->
      <topRoadAll @isChildLoad="isChildLoad" v-if="topRoadAll" />
      <!-- 全部城市 -->
      <wayCity v-if="showwayCity" :clickId="clickId" />
      <!-- 某城市热力图 -->
      <wayCity v-if="showwayCity" :clickId="clickId" />
      <!-- 热门城市 -->
      <hotCity :isHome="isHome" />
      <!-- <cityMapDetails
        v-if="showMapDetails"
        @getMapDetails="getMapDetails"
        :mapCityName="mapCityName"
        :mapCityCode="mapCityCode"
      />-->
      <!-- 左侧数据 -->
      <leftData
        :leftIndex="leftIndex"
        :btnIndex="roadType"
        ref="left"
        @changeLeftIndex="changeLeftIndex"
        @initData="initData"
        @isShowList="isShowList"
        :hotZoneAreas="hotZoneAreas"
        :leftData="leftData"
      />
      <!-- 全国道路右侧详情 -->
      <rightData
        v-if="showRightData"
        :clickId="clickId"
        ref="right"
        :hidedata="hidedata"
        :loadingRight="loadingRight"
        :itemData="objData"
      />

      <!-- 地图 -->
      <mapDrag
        :allData="allData"
        :leftIndex="leftIndex"
        :listDatas="leftDatePath"
        :lnglats="lnglats"
        :showRightData="showRightData"
        :hidedata="hidedata"
        @loadMorePath="loadMorePath"
        :getObjColor="getObjColor"
        :hCityDetails="hCityDetails"
        :enableGeomSubmit="enableGeomSubmit"
        :hotZoneAreas="hotZoneAreas"
        ref="mapDrag"
        :isAutoSet="isAutoSet"
        :pathData="pathData"
        :provinceCodes="provinceCodes"
        @openAllCity="openAllCity"
        :clickId="clickId"
        :isShowHotCityp="isShowHotCity"
        @changeLeftIndex="changeLeftIndex"
        @getHCityDetails="getHCityDetails"
        @openRoadCity="openRoadCity"
        @showNewPos="showNewPos"
        :mapType="1"
      ></mapDrag>
      <!-- 新增站点弹框 -->
      <newPos
        v-if="isShowNewPos"
        :formLabelAlign="formLabelAlign"
        :nLeft="nLeft"
        :nTop="nTop"
        :isAdd="isAdd"
        @giveUp="giveUp"
        @confirmAddSite="confirmAddSite"
      />
    </template>
  </div>
</template>
<script>
import axios from '@/api/road.js'
import mapDrag from '../mapComponents/mapDrag.vue'
import newPos from '../mapComponents/newPos.vue'
import hotCity from '../mapComponents/hotCity.vue'
import leftData from './leftData.vue'
import rightData from './rightData.vue'
import topRoadAll from '../topRoad/list.vue'
import wayCity from '../wayCity/list.vue'
// import cityMapDetails from '../hotCities/map.vue'
import commonFun from '../assets/js/common.js'
export default {
  components: {
    mapDrag,
    hotCity,
    leftData,
    rightData,
    newPos,
    topRoadAll,
    wayCity
    // cityMapDetails
  },
  data() {
    return {
      loading: false,
      topRoadAll: false, //全部道路
      showwayCity: false, //全部城市
      showMapDetails: false, //城市热力图详情
      loadingRight: false,
      dragStatus: false,
      hidedata: false,
      isHome: true, //是否是首页
      AMapUI: null,
      enableGeomSubmit: false,
      AMap: null,
      leftIndex: null,
      showRightData: false,
      leftDatePath: [], //画线数组
      isShowNewPos: false, //是否显示添加站点
      isLoadAllData: false,
      isshowAllRoad: false,
      allData: {},
      // 右侧详情
      objData: {},
      getObjColor: {},
      // 站点参数
      isAdd: true,
      nLeft: 0,
      // cityDataValue: true, //全部城市开关
      // cityValue: true, //道路开关
      nTop: 0,
      roadLen: 0,
      formLabelAlign: {},
      clickId: 0,
      roadType: '全部',
      lnglats: [],
      hCityDetails: [], //鼠标放上去展示热区详情
      hotZoneAreas: [],
      cityCode: '',
      cityDataObj: {}, //热门城市
      isShowHotCity: false,
      roadIds: [],
      pIndex: 0,
      provinceCodes: [], //省份code
      leftDataId: [],
      allhotZoneAreas: [],
      pathData: [], //全部加载分批
      allPaths: [], //全部道路
      roadSArea: [], //某条道路
      isAutoSet: false, //画线是否需要自动变化地图位置
      newPosLimit: false, //新建站点
      isCompressed: true, //是否压缩
      isFirstLoadPath: true, //是否是第一次加载
      defaultDataId: [] //集合道路ID
    }
  },
  props: {
    searchKeyVal: String,
    lat: Number,
    lng: Number
  },
  watch: {},
  created() {
    this.initData(this.roadType, true)
    if (this.$route.query.enableGeomSubmit) {
      this.enableGeomSubmit = true
    }
  },
  mounted() {
    this.pIndex = 0
    this.isshowAllRoad = false
    var _this = this
    // this.isChangeMover=this.$route.path.indexOf('allRoad')==-1?false:true
    // console.log(this.isChangeMover)
    // _this.changeMouver()
  },
  // 销毁组件前清除定时器
  // beforeDestroy() {
  //   window.clearInterval(this.timer)
  //   this.timer = null
  // },
  methods: {
    // 全部道路加载进来
    isChildLoad(roadType, id) {
      this.isChildHref = true
      this.roadIds = [id]
      this.initData(roadType, false, id)
      this.topRoadAll = false
    },
    // 全部道路
    loadMorePath() {
      this.isAutoSet = false
      this.isshowAllRoad = true
      this.isCompressed = true
      var leftDataId = this.leftDataId
      var pIndex = this.pIndex
      this.roadIds = leftDataId.splice(0, 5)
      this.defaultDataId = this.defaultDataId.concat(this.roadIds)
      this.pIndex = pIndex + 1
      var _this = this
      _this.initData(this.roadType, false)
    },
    // 全部城市开关
    openAllCity(isOpen) {
      this.provinceCodes = this.allprovinceCodes
      this.hotZoneAreas = [...this.allhotZoneAreas]
    },

    // 某条道路城市开关
    openRoadCity() {
      if (this.clickId != 0) {
        this.provinceCodes = this.onlyprovinceCodes
        this.hotZoneAreas = [...this.roadSArea]
      }
    },
    // 初始化地图
    async initData(roadType, isFirst, id) {
      let _this = this
      if (roadType != _this.roadType) {
        this.pIndex = 0
      }
      if (!this.isshowAllRoad) {
        _this.loading = true
      }
      if (isFirst) {
        this.leftData = []
        this.isCompressed = true
        this.clickId = 0
        this.isAutoSet = false
        this.showRightData = false
        this.leftDatePath = []
      }
      this.roadType = roadType
      var data = {
        roadType: this.roadType == '全部' ? null : this.roadType,
        cityCode: null,
        roadIds: isFirst ? null : _this.roadIds,
        isCompressed: this.isCompressed
      }
      axios.getTop150Road(data).then(e => {
        if (isFirst) {
          _this.allData = e.data
          if (e.data.lnglats) {
            _this.lnglats = [...e.data.lnglats]
          }
          _this.getObjColor = e.data.colorMap //热区颜色
          var leftData = commonFun.returnColor(_this.allData.leftData, true) //左侧数据
          var leftDataId = []
          for (var v of leftData) {
            leftDataId.push(v.id)
          }
          _this.leftDataId = leftDataId
          _this.leftData = [...leftData]
          _this.roadLen = Math.ceil(this.leftData.length / 5)
          _this.isLoadAllData = true
          _this.loading = false
          _this.allprovinceCodes = [...e.data.provinceCodes]
          // 判断是否需要重新加载全部热区
          if (_this.isFirstLoadPath) {
            _this.provinceCodes = [...e.data.provinceCodes]
            _this.hotZoneAreas = [...e.data.hotZoneAreas]
            _this.allhotZoneAreas = [...e.data.hotZoneAreas]
          }
          // 判断是否需要重新加载全部道路
          if (!_this.isFirstLoadPath) {
            if (_this.$refs.mapDrag.roadValue) {
              // 清空道路
              _this.$refs.mapDrag.clearAllPath()
              _this.allPaths = []
              _this.loadMorePath()
            }
            _this.hotZoneAreas = [...[]]
            _this.provinceCodes = [...[]]

            if (_this.$refs.mapDrag.cityDataValue) {
              _this.provinceCodes = [...e.data.provinceCodes]
              _this.hotZoneAreas = [...e.data.hotZoneAreas]
              _this.allhotZoneAreas = [...e.data.hotZoneAreas]
            } else {
              _this.allhotZoneAreas = [...e.data.hotZoneAreas]
            }
          }
        } else {
          // 是否是全部道路加载进来
          if (_this.isChildHref) {
            _this.isChildHref = false
            _this.changeLeftIndex(parseInt(id))
          } else {
            if (_this.isshowAllRoad) {
              // 是否加载全部
              _this.pathData = [...e.data.leftData]
              var data = _this.allPaths.concat(e.data.leftData)
              _this.allPaths = data
              if (_this.pIndex == _this.roadLen) {
                // if (_this.pIndex == 3) {
                _this.pIndex = 0
                _this.isshowAllRoad = false
                _this.isAutoSet = true
                 _this.loading = false
                _this.leftDataId = _this.defaultDataId
                _this.defaultDataId = []
                return
              } else {
                // 加载全部
                _this.loadMorePath()
              }
            } else {
              // 判断是否有道路数据
              var isHaveData = _this.$refs.mapDrag.changeLsData(e.data.leftData)
              if (isHaveData.length == 0) {
                this.$message({
                  message: '暂无相关道路信息',
                  type: 'warning',
                  duration: 3000,
                  showClose: true
                })
              }

              _this.leftDatePath = [...e.data.leftData]
              if (!_this.$refs.mapDrag.cityDataValue) {
                _this.hotZoneAreas = [...e.data.hotZoneAreas]
              }
              _this.roadSArea = [...e.data.hotZoneAreas]
              _this.provinceCodes = [...e.data.provinceCodes]
              _this.onlyprovinceCodes = [...e.data.provinceCodes]
              // _this.isAutoSet = true
            }
          }
          _this.isLoadAllData = true
          _this.loading = false
        }
        _this.isFirstLoadPath = false
      })
    },
    // 获取站点
    getSiteList() {
      var _this = this
      axios.getListSide({ cityName: null }).then(e => {
        if (e.data) {
          _this.lnglats = [...e.data]
        }
      })
    },
    // 路线和左侧数据关联得ID
    changeLeftIndex(id, isOpen) {
      var _this = this
      this.isshowAllRoad = false
      this.isCompressed = false
      this.isAutoSet = true
      // this.$refs.mapDrag.showDetails=false
      if (isOpen) {
        if (this.clickId == 0) {
          return
        } else {
          id = this.clickId
        }
      } else {
        this.clickId = id
        this.roadIds = [id]
      }
      var arr = this.leftData
      for (var k = 0; k < arr.length; k++) {
        if (arr[k].id == id) {
          _this.$refs.left.changeTop(k)
          arr[k].isShow = true
        } else {
          arr[k].isShow = false
        }
      }
      this.initData(this.roadType, false)
      _this.leftData = [...arr]
      if (_this.leftIndex != id) {
        _this.loadingRight = true
        // 全国道路详情
        axios.getRoadDetails(id, '').then(e => {
          _this.objData = e.data
          _this.showRightData = true
          _this.loadingRight = false
        })
      }
    },
    confirmAddSite() {
      this.getSiteList()
      this.isShowNewPos = false
    },
    // 取消添加站点
    giveUp() {
      if (this.isAdd) {
        //  this.getSiteList()
        var lnglats = this.lnglats
        lnglats.pop()
        this.lnglats = [...lnglats]
      } else {
        this.getSiteList()
      }
      this.$refs.mapDrag.isDblClickM = false
      this.isShowNewPos = false
    },
    showNewPos(e, isAdd, obj) {
      var ww = document.body.clientWidth - 348
      var wh = document.body.clientHeight - 360
      var x = e.x
      var y = e.y
      if (x > ww) {
        x = x - 348
      }
      if (y > wh) {
        y = y - 360
      }
      this.nLeft = x
      this.nTop = y
      this.isAdd = isAdd
      this.formLabelAlign = obj
      this.isShowNewPos = true
    },
    // 鼠标放上去获取城市运营详情
    getHCityDetails(code) {
      var _this = this
      _this.hCityDetails = []
      axios.getHCityDetails(code).then(e => {
        var data = []
        data.push(e.data)
        _this.hCityDetails = [...data]
      })
    },
    // 是否隐藏两侧
    isShowList(e) {
      this.hidedata = e
    }
    // 监听滚动
    // changeMouver() {
    //   var _this = this,
    //     diff = 5000, //未操作触发间隔
    //     firstTime = new Date().getTime(),
    //     lastTime = new Date().getTime(),
    //     indulge = false
    //   //停止
    //   document.querySelector('#bodyData').onmousemove = function() {
    //     indulge = true
    //     firstTime = new Date().getTime()
    //     if (_this.leftData.length > 0) {
    //       clearInterval(_this.$refs.left.switchTime)
    //     }
    //     if (_this.showRightData) {
    //       clearInterval(_this.$refs.right.switchTime)
    //     }
    //   }
    //   //再启动
    //   this.timer = setInterval(function() {
    //     lastTime = new Date().getTime()
    //     if (lastTime - firstTime > diff && indulge) {
    //       indulge = false
    //       if (_this.leftData.length > 0) {
    //         _this.$refs.left.setTimer()
    //       }
    //       if (_this.showRightData) {
    //         _this.$refs.right.setTimer()
    //       }
    //     }
    //   }, 5000)
    // }
    // 某条道路详情函数
    // getMapDetails(cityName, cityCode) {
    //   console.log(cityName, cityCode)
    //   this.mapCityName = cityName
    //   this.mapCityCode = cityCode
    //   this.showMapDetails = true
    // }
    // // 删除站点
    // deleteSide(id) {
    //   console.log(id)
    //   axios.deleteSide({ id: id }).then(e => {
    //     console.log(e)
    //   })
    // }
  }
}
</script>
<style >
.road-operation-main {
  padding: 0 !important;
}
.m-map,
#js-container {
  width: 100%;
  height: 100%;
  min-height: 600px;
  min-width: 1100px;
  position: relative;
  overflow: hidden;
}
button:hover {
  cursor: pointer;
}
.el-loading-mask {
  z-index: 999 !important;
}
.sName {
  margin-left: 10px;
}
</style>